import React from 'react'
import {findDOMNode} from "react-dom"

import NavigationMenuItem from "../../../../menu-items/menu-item"
import {BUS_APP_LAUNCH} from "../../../../../../core/gd/app-manager/@event"
import PersonalView from "../../../../../../core/model2/view/personal-view/personal-view"
import ArrayUtils from "../../../../../../core/gd/utils/array"
// import {MyTasks_SectionType, MyTasksSections} from "../../../../../../views/my-tasks/@const"
import NavigationSection from "../../../../../../core/model2/navigation/navigation-section"
import NavigationMenu_HomeLocalSettings from "../../local-settings"
import AppMyTasks from "../../../../../../views/my-tasks/app"
import {MY_TASKS_CURRENT_VIEW_SET} from "../../../../../../views/my-tasks/@events"
import MyTasksLocalSettings from "../../../../../../views/my-tasks/manager/local-settings";
import {myTasksViewPathDictionary} from "../../../../../../views/my-tasks/@const";

type Props = {
    className?          : string

    navigationSection   : NavigationSection
    view                : PersonalView,
    localSettings       : NavigationMenu_HomeLocalSettings

    style?              : style
    dndPreview?         : any
    dndIsDragged?       : boolean
    hidePopover?        : callback // used when in popover menu (personal views more menu)
    iconMoreClass?      : string    // icon more class optional
}

// const debug = "MainMenu_ItemMyTasks"
const debug = false

export default class MainMenu_ItemMyTasks extends React.Component<Props,any> {

    public debouncedCheckHint       : any
    public view                 : PersonalView

    constructor(props:Props) {
        super(props)


        this.view = props.view

        this.state = {
            selected    : this.view.isOpen,
            useHint     : false
        }

        this.debouncedCheckHint = _.debounce(this._checkHintUsage, 300)
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp)
        gd.bus.subscribe(MY_TASKS_CURRENT_VIEW_SET, this, this.onCurrentViewSet)

        this.debouncedCheckHint()
    }

    componentDidUpdate() {
        this.debouncedCheckHint()
    }

    componentWillUnmount = () => {
        this.debouncedCheckHint.cancel()

        gd.bus.unsubscribe(this)
    };

    onToggleExpandView = () => {
        this.props.localSettings.expandedViews = ArrayUtils.toggleArrayValue(this.props.localSettings.expandedViews, this.view.id)
        this.forceUpdate()
    }

    onClick = () => {
        // this.view.url
        this.view.open()

        if (this.props.navigationSection) {
            this.props.navigationSection.defaultAppUrl = this.view.url
        }

        this.props.hidePopover?.()   // same as func && func() syntaxis
    }

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.view.name, findDOMNode(this), 56, 14)

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    onLaunchApp = (params:any) => {
        // just in case
        if (!this.view) return

        if (this.state.selected) {
            !this.view.isOpen && this.setState({selected: false})
        } else {
            this.view.isOpen && this.setState({selected: true})
        }
    }

    onCurrentViewSet = () => {
        this.forceUpdate()
    }

    render () {
        // patch to prevent errors
        if (!this.view) return false

        const classes = Classes('viewId-'+this.view.id /*required for scroll to node*/, this.props.className)

        const isExpanded = this.props.localSettings.expandedViews.includes(this.view.id)
        // const currentView = (gd.getMainApp() as AppMyTasks)?.getViewType?.()

        debug && console.log(debug, 'render', isExpanded, this.view)

        const myTasksLocalSettings = new MyTasksLocalSettings()

        const viewPath = myTasksViewPathDictionary[myTasksLocalSettings.currentView!]

        let url: string = ""

        if (myTasksLocalSettings.currentViewId === myTasksLocalSettings.currentView) {
            url = "my-tasks/{0}".f(viewPath)
        } else {
            url = "my-tasks/{0}/{1}".f(viewPath, myTasksLocalSettings.currentViewId)
        }

        return (
            <>
                <NavigationMenuItem className               = {classes}
                                    name                    = {this.view.name}
                                    selected                = {!isExpanded && this.state.selected}
                                    icon                    = {Classes('icon', this.view.icon)}
                                    style                   = {this.props.style}
                                    dndPreview              = {this.props.dndPreview}
                                    dndIsDragged            = {this.props.dndIsDragged}
                                    url                     = {url}
                                    saveUrl                 = {true}
                                    onClick                 = {this.onClick}
                                    moreMenuOptions         = {this.props.view.menuMoreOptions()}
                                    iconMoreClass           = {this.props.iconMoreClass}
                                    isShared                = {false}
                                    isExpandable            = {false}
                                    isExpanded              = {isExpanded}
                                    {...this.props}
                                    onMenuItemHandleClick   = {this.onToggleExpandView}/>

                {/*{isExpanded && _.map(MyTasksSections, (section: MyTasks_SectionType, key: string) => {
                    return <NavigationMenuItem key          = {key}
                                               name         = {section.label}
                                               selected     = {isExpanded && this.state.selected && currentView === key}
                                               icon         = {Classes('icon', section.icon)}
                                               onClick      = {()=>{gd.goTo(section.url)}}
                                               level        = {1}/>
                })}*/}
            </>
        )
    }
}
